const AMPLITUDE = "AMPLITUDE";
export const AMPLITUDE_SET_USER_ID_SUCCESS = `${AMPLITUDE}_SET_USER_ID_SUCCESS`;

export const AMPLITUDE_LOG_EVENT = `${AMPLITUDE}_LOG_EVENT`;
export const AMPLITUDE_LOG_EVENT_SUCCESS = `${AMPLITUDE_LOG_EVENT}_SUCCESS`;
export const AMPLITUDE_LOG_EVENT_FAILURE = `${AMPLITUDE_LOG_EVENT}_FAILURE`;
